"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poetryFilesToScannedProjects = exports.pipFilesToScannedProjects = void 0;
const pip_1 = require("./pip");
Object.defineProperty(exports, "pipFilesToScannedProjects", { enumerable: true, get: function () { return pip_1.pipFilesToScannedProjects; } });
const poetry_1 = require("./poetry");
Object.defineProperty(exports, "poetryFilesToScannedProjects", { enumerable: true, get: function () { return poetry_1.poetryFilesToScannedProjects; } });
//# sourceMappingURL=index.js.map